import { IFpLoggerNoiseTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-tab-connect-service';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

export interface IFpLoggerNoiseManagerState {
  popupId: string | null;
  selectedData: ILdLogger | null;
  loading: boolean;
  initialized: boolean;
  activeTabConnectService: IFpLoggerNoiseTabConnectService | null;
}

export const initialFpLoggerNoiseManagerState: IFpLoggerNoiseManagerState = {
  popupId: null,
  selectedData: null,
  loading: false,
  initialized: false,
  activeTabConnectService: null,
};
